/**
 * Created by mathieudeumie on 04/08/2014.
 */

angular.module('FlexyBeautyApp.services').
    factory('HumanResourceStatView',[
        function ()
        {
            var HumanResourceStatView = function(id, label,firstName,lastName, hasPlanning)
            {
                if(id)
                    this.id = id;
                else
                    this.id = 0;
                if(label)
                    this.label = label;
                else
                    this.label = "";
                if(firstName)
                    this.firstName = firstName;
                else
                    this.firstName = "";
                if(label)
                    this.lastName = lastName;
                else
                    this.lastName = "";
                this.ca = 0;
                this.caServices = 0;
                this.caProducts = 0;
                this.caCures = 0;
                this.caGiftItems = 0;
                this.caLoyaltyCards = 0;
                this.occupationRates = [];
                this.nbBookings = 0;
                this.nbSales = 0;
                this.hasPlanning = hasPlanning;
            };

            HumanResourceStatView.prototype.getOccupationRate = function()
            {
                var rate = 0;
                for(var i=0; i<this.occupationRates.length; i++)
                {
                    rate += this.occupationRates[i];
                }
                if(this.occupationRates.length > 0)
                    return Math.round((rate / this.occupationRates.length) * 100) / 100;
                else
                    return 0;
            };

            HumanResourceStatView.prototype.cleanData = function()
            {
                this.cleanOccupationRate();
                this.cleanNbBookings();
                this.cleanNbSales();
                this.cleanCa();
            };
            HumanResourceStatView.prototype.cleanOccupationRate = function()
            {
                this.occupationRates = [];
            };
            HumanResourceStatView.prototype.cleanNbBookings = function()
            {
                this.nbBookings = 0;
            };
            HumanResourceStatView.prototype.cleanNbSales = function()
            {
                this.nbSales = 0;
            };
            HumanResourceStatView.prototype.cleanCa = function()
            {
                this.ca = 0;
                this.caServices = 0;
                this.caProducts = 0;
                this.caCures = 0;
                this.caGiftItems = 0;
                this.caLoyaltyCards = 0;
            };

            return HumanResourceStatView;
        }
    ]);


// WEBPACK FOOTER //
// ./js/services/views/statistics/HumanResourceStatView.js